/**
* @file gatsby-browser.js
* @author Ice(chenzhouji@baidu.com)
*/
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/js/dist/tab';
import 'prismjs/themes/prism.css';
import score from './src/templates/acg-portal/components/Score/score';

export const onRouteUpdate = () => {
    // 每次切换路由的时候都要尝试加载评分条（内部会判断是否需要重新渲染）
    score();
};

// export const disableCorePrefetching = () => true;
